import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { GucciCognito } from '@gucci-private/gucci-cognito-library'
import { manageParameters } from './utils/utils'
import axios from 'axios';


manageParameters();

window.$VMT = window.$VMT || {};

window.$VMT.cognito = new GucciCognito({
    domain: process.env.REACT_APP_DOMAIN,
    region: process.env.REACT_APP_REGION,
    appClientId: process.env.REACT_APP_APP_CLIENT_ID,
    redirectURI: process.env.REACT_APP_REDIRECT_URI,
    userPoolId: process.env.REACT_APP_USER_POOL_ID
});
window.$VMT.cognito.run(() => {
    window.location.href = window.location.origin + window.location.pathname;
});

let started = false;
document.addEventListener('CognitoAuthorization.loaded', (ev) => {
    console.log(ev);

    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['X-GGD-Security'] = window.$VMT.cognito.oauthToken;
    axios.defaults.headers.common['X-GGD-Region'] = window.$VMT.cognito.region;
    axios.defaults.headers.common['X-GGD-UPID'] = window.$VMT.cognito.userPoolId;
    axios.defaults.headers.common['X-GGD-Domain'] = window.$VMT.cognito.domain;


    if (!started) {
        console.log(window.$VMT.cognito.oauthToken);
        ReactDOM.render(<App />, document.getElementById('root'));
        started = true;
    }
})


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
